"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductAttributeControl = void 0;
const react_1 = __importStar(require("react"));
const attributes_1 = require("../../../../client/attributes");
const components_1 = require("../../../../components");
const localization_1 = require("../../../../../localization");
const ProductAttributeControl = ({ productTreeNodeId, selectedAttributeId, onChange, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { data, isLoading, pagination: { hasNextPage, isLoadingMore, onNextPage, }, onSearch, } = (0, attributes_1.useGetStrategyAttributes)({
        productTreeNodeId,
    });
    const options = (0, react_1.useMemo)(() => {
        var _a;
        const loadedOptions = (_a = data === null || data === void 0 ? void 0 : data.map(({ node: { label } }) => ({ label, value: label }))) !== null && _a !== void 0 ? _a : [];
        // Prepend selected attribute if not in loaded page (pagination handling)
        if (selectedAttributeId && !loadedOptions.some((opt) => opt.value === selectedAttributeId)) {
            return [{ label: selectedAttributeId, value: selectedAttributeId }, ...loadedOptions];
        }
        return loadedOptions;
    }, [data, selectedAttributeId]);
    return (react_1.default.createElement(components_1.AutocompleteSelector, { onChange: onChange, options: options, selected: selectedAttributeId, placeholder: t({ key: 'BULK_EDIT_ATTRIBUTES_DIALOG_PLACEHOLDER' }), hasNextPage: hasNextPage, isLoading: isLoading, moreItemsLoading: isLoadingMore, noOptionsText: t({ key: 'NO_DATA_AVAILABLE' }), onLoadMore: onNextPage, onSearch: onSearch }));
};
exports.ProductAttributeControl = ProductAttributeControl;
exports.default = exports.ProductAttributeControl;
